import { publicUrl } from "@/utils/applicationUrls"

// CKEditor uses its own XHR, so it does not inherit Axios's cookie settings.
export function configureEditorUploads(editor) {
	editor.on("fileUploadRequest", (event) => {
		event.data.fileLoader.xhr.withCredentials = true
	})

	// Adapt our API response to CKEditor's upload lifecycle. Its filebrowser
	// callback fills the link/image URL and selects the appropriate dialog tab.
	editor.on("fileUploadResponse", (event) => {
		event.stop()
		try {
			const response = JSON.parse(event.data.fileLoader.xhr.responseText)
			if (!response || typeof response.url !== "string" || !response.url.trim()) {
				throw new Error("Missing upload URL")
			}
			const url = response.url.trim()
			if (url.startsWith("/") && !url.startsWith("//")) {
				event.data.url = publicUrl(url)
			} else {
				const parsed = new URL(url)
				if (!["https:", "http:"].includes(parsed.protocol) || parsed.username || parsed.password) {
					throw new Error("Invalid upload URL")
				}
				event.data.url = parsed.href
			}
		} catch (error) {
			event.data.message = "The server did not return an uploaded file URL. Please try again."
			event.cancel()
		}
	})
}
